import React from 'react';

const ModalHeader = ({
    title,
    onClose,
    noButton,
    className,
}: {
    title: string;
    onClose: () => void;
    noButton?: boolean;
    className?: string;
}) => {
    return (
        <div className={`gds-modal__header ${className}`}>
            <h2 className="gds-modal__title gds-text--header-sm -color-tx-lt-4">
                {title}
            </h2>
            {!noButton && (
                <button
                    type="button"
                    className="gds-modal__close-button"
                    onClick={onClose}
                />
            )}
        </div>
    );
};

export default ModalHeader;
